import mitt from "mitt";
import { BusEvents } from "@/common/buses/metrics/types";
export const bus = mitt<BusEvents>();
